// extracted by mini-css-extract-plugin
export default {"ListOfReferences":"Mefn9A99","header":"Dx30TJ31","table":"V36vUwlr","table__clickable":"FrpJaG5t","close":"_2XNYxnez","badge":"v2QH5iDx","new":"Ws8f551Z","userCard":"uNnxJK4F","userCard__content":"DdiCpW9_","userCard__buttons":"uyBWjbTz"};
    if(module.hot) {
      // 1776432170535
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  